import { CONSELHOS_PROFISSIONAIS } from '../constants/conselhosProfissionais';

export const CONSELHO_OUTRO = 'OUTRO';

const REGISTRO_REGEX = /^[A-Za-z0-9.-]+$/;
const OUTRO_REGEX = /^[A-Za-z0-9./\- ]+$/;
const MAX_OUTRO = 60;
const MAX_REGISTRO = 20;

const getConselhoProfissional = (value) =>
  CONSELHOS_PROFISSIONAIS.find((c) => c.value === value) || null;

const resolverSigla = ({ value, outro } = {}) => {
  if (value === CONSELHO_OUTRO) return (outro || '').trim();
  const conselho = getConselhoProfissional(value);
  return conselho ? conselho.sigla : '';
};

export const montarConselhoClasse = ({ value, outro, registro } = {}) => {
  const sigla = resolverSigla({ value, outro });
  const reg = (registro || '').trim();
  if (!sigla || !reg) return '';
  return `${sigla} ${reg}`;
};

export const validarConselhoClasse = ({ value, outro, registro } = {}) => {
  if (!value) return 'Selecione o conselho de classe.';

  if (value === CONSELHO_OUTRO) {
    const texto = (outro || '').trim();
    if (!texto) return 'Informe a sigla do conselho de classe.';
    if (texto.length > MAX_OUTRO) return 'A sigla informada é muito longa.';
    if (!OUTRO_REGEX.test(texto)) return 'Sigla do conselho inválida.';
  } else if (!getConselhoProfissional(value)) {
    return 'Conselho de classe inválido.';
  }

  const reg = (registro || '').trim();
  if (!reg) return 'Informe o registro profissional.';
  if (reg.length > MAX_REGISTRO) return 'Registro profissional muito longo.';
  if (!REGISTRO_REGEX.test(reg)) {
    return 'Registro profissional inválido (use apenas letras, números, ponto e hífen).';
  }
  return '';
};
